<h2 mat-dialog-title>Material Solicitado</h2>
<mat-dialog-content>
  <mat-card>
    <mat-card-title>
      <h4>{{ procedureObject[record.procedure] }}</h4>
      <div class="datetime-div">
        <span>{{ formatDate(record.interventionDatetime) }}</span>
      </div>
    </mat-card-title>

    <div>
      <span><b>Folio:</b></span>
      <p>{{ record.fileNumber }}</p>

      <span><b>Episodio:</b></span>
      <p>{{ record.episode }}</p>

      <span><b>Especialidad:</b></span>
      <p>{{ record.specialty ? specialtyObject[record.specialty] : "-" }}</p>

      <span><b>Doctor:</b></span>
      <p>{{ record.doctor ? doctorObject[record.doctor] : "-" }}</p>

      <span><b>Nombre del paciente:</b></span>
      <p>{{ record.patient ? patientObject[record.patient]?.name : "-" }}</p>
    </div>

    <!-- Tabla por categoría -->
    @for (cat of categoryTables; track cat) {
      <mat-card>
        <h4>Solicitud de Insumos - {{ cat.label }}</h4>
        <div class="table-container mat-elevation-z8">
          <table mat-table [dataSource]="cat.dataSource" class="mat-elevation-z8 demo-table">
            <ng-container matColumnDef="itemCode">
              <th mat-header-cell *matHeaderCellDef>Código</th>
              <td mat-cell *matCellDef="let element">{{ element.itemCode }}</td>
            </ng-container>
            <ng-container matColumnDef="itemDescription">
              <th mat-header-cell *matHeaderCellDef>Descripción</th>
              <td mat-cell *matCellDef="let element">{{ element.itemDescription }}</td>
            </ng-container>
            <ng-container matColumnDef="quantity">
              <th mat-header-cell *matHeaderCellDef>Cantidad</th>
              <td mat-cell *matCellDef="let element">{{ element.quantity }}</td>
            </ng-container>
            <ng-container matColumnDef="delivery">
              <th mat-header-cell *matHeaderCellDef>Entregado</th>
              <td mat-cell *matCellDef="let element">{{ element.delivery }}</td>
            </ng-container>
            <ng-container matColumnDef="consumption">
              <th mat-header-cell *matHeaderCellDef>Consumido</th>
              <td mat-cell *matCellDef="let element">{{ element.consumption }}</td>
            </ng-container>
            <ng-container matColumnDef="refund">
              <th mat-header-cell *matHeaderCellDef>Devuelto</th>
              <td mat-cell *matCellDef="let element">{{ element.refund }}</td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>Tipo de insumo</th>
              <td mat-cell *matCellDef="let element">{{ element.type }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </mat-card>
    }

  </mat-card>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>